import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { startLoading, stopLoading } from '../../../slices/loading.slice';
import { closeModal } from '../../../slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getStorageValue } from '../../../utils/cookies';
import './delete-conformation-modal.scss'
import { deleteCropYearGrid, postCropYearGrid } from '../../../slices/cropyear.slice';

const DeleteModuleModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { selectedId,menuName } = useAppSelector((state) => state.applicationdropdown);
  useEffect(() => {
    dispatch(stopLoading());
  }, [dispatch]);
  const handleCancel = () => {
    dispatch(closeModal());
  };
  const handleDelete = () => {
    if (!selectedId) {
      toast.error("Invalid item selected");
      return;
    }
    dispatch(startLoading());
    if(menuName === 'ServiceAgreements')
    {
      
    }
    else if(menuName === 'CropYear'){
      dispatch(deleteCropYearGrid(selectedId))
        .unwrap()
        .then(() => {
          dispatch(closeModal());
          const userId = getStorageValue('user_id') || '';
          dispatch(postCropYearGrid(userId))
          toast.success("Successfully deleted");
        })
        .catch((error) => {
          console.error('Delete failed:', error);
          toast.error("Failed to delete item");
        })
        .finally(() => {
          dispatch(stopLoading());
        });
      }
  };
  return (
    <div className='modal-container'>
      <div>
        <p>Are you sure want to delete the record?</p>
      </div>
      {/* <div className='modal-buttons'>
        <CustomButton onClick={handleCancel} variant='outlined'>
          Cancel
        </CustomButton>
        <CustomButton onClick={handleDelete}>Delete</CustomButton>
      </div> */}
      <div className='buttonContainer'>
            <button className='cancelButton' onClick={handleCancel}>Cancel</button>
            <button className='saveButton' onClick={handleDelete} >Delete</button>
          </div>
    </div>
  );
};
export default DeleteModuleModal;